export const T = {
  en_GB: {
    delete: "Delete",
    // Dialog
    editView: "Edit View",
    addNewView: "Add New View",
    updateViewDescription: "Update the view configuration below.",
    createViewDescription: "Create a new view to filter clients by specific criteria.",
    // Form fields
    name: "Name",
    nameRequired: "Name is required",
    description: "Description",
    viewNamePlaceholder: "e.g., Norwegian Clients",
    optionalDescription: "Optional description",
    setAsDefault: "Set as default view",
    // Filters
    filters: "Filters",
    addFilter: "Add Filter",
    noFiltersHint: "No filters added. Add filters to narrow down the client list.",
    filterNumber: (number: string) => `Filter ${number}`,
    standardFields: "Standard Fields",
    clientFields: "Client Fields",
    activityDate: "Activity Date (legacy)",
    selectDateField: "Select date field",
    // Activity date filter (legacy, rolling window)
    inLast: "in last",
    notInLast: "not in last",
    monthSingular: "1 month",
    monthsPlural: (count: string) => `${count} months`,
    // Actions
    cancel: "Cancel",
    unavailableFilter:
      "This filter uses a field or option that is no longer available. It is kept as is.",
    save: "Save",
    addView: "Add View",
    // Errors
    failedToSave: "Failed to save custom field",
  },
  nb_NO: {
    delete: "Slett",
    // Dialog
    editView: "Rediger visning",
    addNewView: "Legg til ny visning",
    updateViewDescription: "Oppdater visningskonfigurasjonen nedenfor.",
    createViewDescription: "Opprett en ny visning for å filtrere kunder etter bestemte kriterier.",
    // Form fields
    name: "Navn",
    nameRequired: "Navn er påkrevd",
    description: "Beskrivelse",
    viewNamePlaceholder: "f.eks. Norske kunder",
    optionalDescription: "Valgfri beskrivelse",
    setAsDefault: "Sett som standardvisning",
    // Filters
    filters: "Filtre",
    addFilter: "Legg til filter",
    noFiltersHint: "Ingen filtre lagt til. Legg til filtre for å begrense kundelisten.",
    filterNumber: (number: string) => `Filter ${number}`,
    standardFields: "Standardfelt",
    clientFields: "Kundefelt",
    activityDate: "Aktivitetsdato (utgått)",
    selectDateField: "Velg datofelt",
    // Activity date filter (legacy, rolling window)
    inLast: "i løpet av siste",
    notInLast: "ikke i løpet av siste",
    monthSingular: "1 måned",
    monthsPlural: (count: string) => `${count} måneder`,
    // Actions
    cancel: "Avbryt",
    unavailableFilter:
      "Dette filteret bruker et felt eller alternativ som ikke lenger er tilgjengelig. Det beholdes som det er.",
    save: "Lagre",
    addView: "Legg til visning",
    // Errors
    failedToSave: "Kunne ikke lagre egendefinert felt",
  },
} as const;

export const ACTIVITY_DATE_LABELS = {
  en_GB: {
    lastLogin: "Last Login",
    lastInfoUpdated: "Last Updated",
    lastFlowActivity: "Last Flow Activity",
    lastFlowCompleted: "Last Flow Completed",
    lastAccountSynced: "Last Account Synced",
    lastSignedDocument: "Last Signed Document",
    createdAt: "Created",
  },
  nb_NO: {
    lastLogin: "Siste innlogging",
    lastInfoUpdated: "Sist oppdatert",
    lastFlowActivity: "Siste flytaktivitet",
    lastFlowCompleted: "Siste fullførte flyt",
    lastAccountSynced: "Siste kontosynkronisering",
    lastSignedDocument: "Siste signerte dokument",
    createdAt: "Opprettet",
  },
} as const;
